import { render, staticRenderFns } from "./TabsSwiper.vue?vue&type=template&id=2aa22b77&"
import script from "./TabsSwiper.vue?vue&type=script&lang=js&"
export * from "./TabsSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports